import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContainerVm } from 'qp-ui-interface';
import { getCarouselType, getShowPlayIcon, getShowProgress } from '../../utils/cardsCarouselUtils';
import { CarouselType } from '../cards-carousel/model/cards-carousel-models';
import { trackByKey } from '../../utils/trackBy';

@Component({
  selector: 'app-cards-carousel-list',
  templateUrl: './cards-carousel-list.component.html',
  styleUrls: ['./cards-carousel-list.component.scss']
})
export class CardsCarouselListComponent implements OnInit {
  @Output() nextPage = new EventEmitter();
  @Input() containers: ContainerVm[] = [];
  @Input() initVerticalIndex = 0;

  trackById = trackByKey<ContainerVm, 'id'>('id');
  constructor() { }

  ngOnInit(): void {
  }

  carouselType(container: ContainerVm): CarouselType {
    return getCarouselType(container);
  }

  showPlayIcon(container: ContainerVm): boolean {
    return getShowPlayIcon(container);
  }

  showProgress(container: ContainerVm): boolean {
    return getShowProgress(container);
  }

}
